import { makeAutoObservable } from 'mobx';
import {
  defaultPercentage,
  TeamsSortBy,
} from 'pages/iPriseV2/common/enum/TeamUserRoles';

export class BusinessHeadJobQueueService {
  unAllocatedPage = 0;
  unAllocatedRowsPerPage = 50;
  assignedPage = 0;
  assignedRowsPerPage = 50;
  readyForReviewPage = 0;
  readyForReviewRowsPerPage = 50;
  readyForApprovedPage = 0;
  readyForApprovedRowsPerPage = 50;
  submittedPage = 0;
  submittedRowsPerPage = 50;
  // Bench Queue pagination
  benchAllJobsPage = 0;
  benchAllJobsRowsPerPage = 50;
  benchMyJobsPage = 0;
  benchMyJobsRowsPerPage = 50;
  benchOverduePage = 0;
  benchOverdueRowsPerPage = 50;
  benchClosedPage = 0;
  benchClosedRowsPerPage = 50;
  searchTerm = '';
  mainTab = 1; // 0: Bench Queue, 1: Job Queue
  jobSubTab = 0; // For Job Queue
  unAllocatedSubTab = 0; // 0 for TL, 1 for Recruiter
  assignedSubTab = 0; // 0 for Recruiter, 1 for TL
  benchSubTab = 0; // For Bench Queue
  selectedTeam = '';
  selectedTeamName = '';
  selectedSort = String(TeamsSortBy.NEWEST_FIRST);
  percentage = defaultPercentage;

  constructor() {
    makeAutoObservable(this);
  }

  setUnAllocatedPage(page: number) {
    this.unAllocatedPage = page;
  }

  setUnAllocatedRowsPerPage(rowsPerPage: number) {
    this.unAllocatedRowsPerPage = rowsPerPage;
    this.unAllocatedPage = 0;
  }

  setAssignedPage(page: number) {
    this.assignedPage = page;
  }

  setAssignedRowsPerPage(rowsPerPage: number) {
    this.assignedRowsPerPage = rowsPerPage;
    this.assignedPage = 0;
  }

  setReadyForReviewPage(page: number) {
    this.readyForReviewPage = page;
  }

  setReadyForReviewRowsPerPage(rowsPerPage: number) {
    this.readyForReviewRowsPerPage = rowsPerPage;
    this.readyForReviewPage = 0;
  }

  setReadyForApprovedPage(page: number) {
    this.readyForApprovedPage = page;
  }

  setReadyForApprovedRowsPerPage(rowsPerPage: number) {
    this.readyForApprovedRowsPerPage = rowsPerPage;
    this.readyForApprovedPage = 0;
  }

  setSubmittedPage(page: number) {
    this.submittedPage = page;
  }

  setSubmittedRowsPerPage(rowsPerPage: number) {
    this.submittedRowsPerPage = rowsPerPage;
    this.submittedPage = 0;
  }

  // Bench Queue setters
  setBenchAllJobsPage(page: number) {
    this.benchAllJobsPage = page;
  }

  setBenchAllJobsRowsPerPage(rowsPerPage: number) {
    this.benchAllJobsRowsPerPage = rowsPerPage;
    this.benchAllJobsPage = 0;
  }

  setBenchMyJobsPage(page: number) {
    this.benchMyJobsPage = page;
  }

  setBenchMyJobsRowsPerPage(rowsPerPage: number) {
    this.benchMyJobsRowsPerPage = rowsPerPage;
    this.benchMyJobsPage = 0;
  }

  setBenchOverduePage(page: number) {
    this.benchOverduePage = page;
  }

  setBenchOverdueRowsPerPage(rowsPerPage: number) {
    this.benchOverdueRowsPerPage = rowsPerPage;
    this.benchOverduePage = 0;
  }

  setBenchClosedPage(page: number) {
    this.benchClosedPage = page;
  }

  setBenchClosedRowsPerPage(rowsPerPage: number) {
    this.benchClosedRowsPerPage = rowsPerPage;
    this.benchClosedPage = 0;
  }

  setSearchTerm(term: string) {
    this.searchTerm = term;
    this.unAllocatedPage = 0;
    this.assignedPage = 0;
    this.readyForReviewPage = 0;
    this.readyForApprovedPage = 0;
    this.submittedPage = 0;
    // Reset bench queue pages
    this.benchAllJobsPage = 0;
    this.benchMyJobsPage = 0;
    this.benchOverduePage = 0;
    this.benchClosedPage = 0;
  }

  reset() {
    this.unAllocatedPage = 0;
    this.unAllocatedRowsPerPage = 50;
    this.assignedPage = 0;
    this.assignedRowsPerPage = 50;
    this.readyForReviewPage = 0;
    this.readyForReviewRowsPerPage = 50;
    this.readyForApprovedPage = 0;
    this.readyForApprovedRowsPerPage = 50;
    this.submittedPage = 0;
    this.submittedRowsPerPage = 50;
    // Reset bench queue
    this.benchAllJobsPage = 0;
    this.benchAllJobsRowsPerPage = 50;
    this.benchMyJobsPage = 0;
    this.benchMyJobsRowsPerPage = 50;
    this.benchOverduePage = 0;
    this.benchOverdueRowsPerPage = 50;
    this.benchClosedPage = 0;
    this.benchClosedRowsPerPage = 50;
    this.searchTerm = '';
    this.mainTab = 1;
    this.jobSubTab = 0;
    this.unAllocatedSubTab = 0;
    this.assignedSubTab = 0;
    this.benchSubTab = 0;
    this.selectedTeam = '';
    this.selectedTeamName = '';
    this.selectedSort = String(TeamsSortBy.NEWEST_FIRST);
    this.percentage = defaultPercentage;
  }

  setMainTab(tab: number) {
    this.mainTab = tab;
  }

  setJobSubTab(tab: number) {
    this.jobSubTab = tab;
  }

  setUnAllocatedSubTab(tab: number) {
    this.unAllocatedSubTab = tab;
  }

  setAssignedSubTab(tab: number) {
    this.assignedSubTab = tab;
  }

  setBenchSubTab(tab: number) {
    this.benchSubTab = tab;
  }

  setSelectedTeam(team: string) {
    this.selectedTeam = team;
  }

  setSelectedTeamName(teamName: string) {
    this.selectedTeamName = teamName;
  }

  setSelectedSort(sort: string) {
    this.selectedSort = sort;
  }

  setPercentage(value: string) {
    this.percentage = value;
  }
}

export const businessHeadJobQueueService = new BusinessHeadJobQueueService();
